import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import {
  actions as filesActions,
  selectors as filesSelectors,
} from '../../../store/files';

import { debounce } from '../../common/utils';
import { FilePropType } from '../../common/types';
import Dialog from '../../common/Dialog';

class FileDialog extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.node,
    mimeType: PropTypes.string,
    competitionId: PropTypes.string,
    fetchFiles: PropTypes.func.isRequired,
    createFile: PropTypes.func.isRequired,
    files: PropTypes.arrayOf(FilePropType),
    onSelectFile: PropTypes.func.isRequired,
    isPublic: PropTypes.bool,
    isTeacher: PropTypes.bool,
  };

  static defaultProps = {
    title: null,
    mimeType: 'image/*',
    competitionId: null,
    files: [],
    isPublic: false,
    isTeacher: false,
  };

  state = {
    fileSearch: '',
    failedFileImages: {},
  };

  onDialogOpen = () => {
    const { mimeType, competitionId } = this.props;

    this.props.fetchFiles({
      competitionId,
      mime_type: mimeType,
      sort_by: 'created_at',
      limit: 10,
    });
  };

  onFileSearchChange = event => {
    this.setState({ fileSearch: event.target.value }, () => {
      this.onDoFileSearch();
    });
  };

  onFileSearch = () => {
    const { mimeType, competitionId } = this.props;
    const { fileSearch: filename } = this.state;

    if (filename) {
      this.props.fetchFiles({ competitionId, mime_type: mimeType, filename });
    } else {
      this.props.fetchFiles({
        competitionId,
        mime_type: mimeType,
        sort_by: 'created_at',
        limit: 10,
      });
    }
  };

  onDoFileSearch = debounce(() => {
    this.onFileSearch();
  }, 200);

  onFileImageFail = fileId => {
    const { failedFileImages } = this.state;
    this.setState({
      failedFileImages: { ...failedFileImages, [fileId]: true },
    });
  };

  onUploadFile = event => {
    if (!event.target.files.length) return;

    const { competitionId, isPublic, isTeacher } = this.props;
    const [file] = event.target.files;

    this.props.createFile({
      competitionId,
      file,
      filename: file.name,
      is_public: isPublic,
      is_teacher: isTeacher,
      disableRedirect: true,
    });
  };

  render() {
    const { title, mimeType, competitionId, files } = this.props;
    const { fileSearch, failedFileImages } = this.state;

    return (
      <Dialog
        id={this.props.id}
        title={
          title || (
            <FormattedMessage
              id="file-dialog-select-file"
              defaultMessage="Valitse kuva"
            />
          )
        }
        onOpen={this.onDialogOpen}
        footer={false}
      >
        <div className="form-group">
          <label htmlFor="search-filename">
            <FormattedMessage
              id="file-dialog-search-filename"
              defaultMessage="Hae tiedostonimellä"
            />
          </label>

          <input
            id="search-filename"
            className="form-control"
            type="text"
            value={fileSearch}
            onChange={this.onFileSearchChange}
          />
        </div>

        <div className="d-flex flex-wrap mt-4">
          {files.map(file => (
            <div key={file.id} className="FileDialog-file col-6 px-2 mb-3">
              <button
                type="button"
                className="btn btn-transparent"
                data-dismiss="modal"
                onClick={() => this.props.onSelectFile(file)}
              >
                <div className="row border">
                  <div
                    className="col-auto border-left px-0 d-flex align-items-center justify-content-center"
                    style={{
                      width: '50px',
                      height: '50px',
                    }}
                  >
                    {!failedFileImages[file.id] ? (
                      <img
                        src={
                          competitionId
                            ? `/api/competitions/${competitionId}/files/${file.id}/content`
                            : `/api/files/${file.id}/content`
                        }
                        className="h-100 w-100"
                        alt={file.filename}
                        onError={() => this.onFileImageFail(file.id)}
                      />
                    ) : (
                      <i className="fas fa-file-image fa-2x" />
                    )}
                  </div>

                  <div
                    className="col d-flex align-items-center"
                    style={{ minWidth: 0 }}
                  >
                    <span className="text-truncate">{file.filename}</span>
                  </div>

                  <div className="col-auto d-flex align-items-center">
                    <i
                      className={classNames('far', {
                        'fa-eye': file.is_public,
                        'fa-eye-slash': !file.is_public,
                      })}
                    />
                  </div>
                </div>
              </button>
            </div>
          ))}

          <div
            className={classNames('FileDialog-file', 'px-2', 'mb-3', {
              'col-6': files.length % 2 !== 0,
              'col-12': files.length % 2 === 0,
            })}
          >
            <button type="button" className="btn btn-primary px-0">
              <div
                className="form-group d-flex align-items-center justify-content-center mb-0"
                style={{ height: '50px' }}
              >
                <label htmlFor="file" className="mb-0">
                  <i className="fas fa-plus mr-2 icon-center" />
                  <FormattedMessage
                    id="file-dialog-new-file"
                    defaultMessage="Lisää"
                  />
                </label>

                <input
                  id="file"
                  type="file"
                  accept={mimeType}
                  className="form-control-file"
                  onChange={this.onUploadFile}
                />
              </div>
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      files: filesSelectors.files(state),
    }),
    dispatch =>
      bindActionCreators(
        {
          fetchFiles: filesActions.fetchAll,
          createFile: filesActions.create,
        },
        dispatch
      ),
    (state, dispatch, props) => ({
      ...state,
      files: state.files.filter(f => f.competition_id === props.competitionId),
      ...dispatch,
      ...props,
    })
  )(FileDialog)
);
